import { useContext } from "react"
import { CommandMenu, CommandMenuTrigger } from "~/components/CommandMenu"
import { Add } from "~/components/Single"
import { Position } from "~/components/Position"
import { MultiContext } from "~/contexts/MultiContext"

export function Multi() {
  const { data, gridConfig, layout } = useContext(MultiContext)

  return (
    <>
      <CommandMenu />
      <CommandMenuTrigger />
      <div
        className={`grid grid-flow-row-dense grid-cols-1 transition-all duration-500 ${gridConfig.gridStyle}`}
      >
        {data.map(({ uuid }) => (
          <Position key={uuid} uuid={uuid} />
        ))}
        {layout - data.length > 0 && <Add />}
      </div>
    </>
  )
}
